<nav class="navbar navbar-expand navbar-light bg-light d-flex flex-row flex-wrap">
    <div class="container-fluid m-2">
        <a class="navbar-brand"><img width="120" height="40" src="../../../assets/img/revature_logo.png" alt=""></a>
    </div>
</nav>